module.exports = __webpack_public_path__ + "static/media/Screenshot_3.c3002119.png";